import { Component, Vue, Ref, Prop, Inject} from 'vue-property-decorator'
import {permissionE} from './types'
import {getFormula} from '@/utils/formula'
import {authorityEdit} from '@/utils/common'
import {AppModule} from '@/store/modules/app'
import {once} from 'lodash'
let reg = /#queId_(\S+?)\$/g
@Component({
  name: 'widgetCommon'
})
export default class extends Vue {
  @Prop({default: () => ({})}) public item!: any
  @Prop({default: () => ({})}) public form!: any
  // 展示在table/设置/新增编辑记录/工作流添加记录的不通情况的标识 inCell/config/record/record_insert
  @Prop({default: ''}) public type!: string
  // 添加或编辑
  @Prop({default: 'add'}) public state!: string
  @Prop({default: false}) public isAdmin!: boolean
  @Prop({default: true}) public canEdit!: boolean
  @Prop({default: () => ({})}) public fieldsMap!: any
  @Prop({default: ''}) public priorityAuthority!: string
  @Prop({default: ''}) public isReadOnly!: boolean
  public formulaField = new Set<string>()
  public getformulaField = once(() => {
    // let set = new Set<string>()
    this.item.defaultValue.replace(reg, (match, $1) => {
      this.formulaField.add($1)
    })
    // this.formulaField = set
  })
  public get name () {
    return this.type === 'inCell' ? '' : (this.item.name || this.item.fieldName)
  }
  public get commonRule () {
    // 优先判断审批权限
    if (this.priorityAuthority && this.priorityAuthority === 'required') {
      return [{ required: true, message: '必填', trigger: 'onBlur' }]
    } else if (this.priorityAuthority) {
      return []
    } 
    let v = this.item.validate || []
    if (v.includes(1)) {
      return [{ required: true, message: '必填', trigger: 'onBlur' }]
    }
    return []
  }
  public get required () {
    return this.commonRule.length === 1
  }
  public get disabled () {
    if (this.isReadOnly) {
      return true
    }
    // 字段配置权限
    if (this.priorityAuthority && this.priorityAuthority === 'visible') {
      return true
    } else if (this.priorityAuthority) {
      return false
    } 
    if ((this.item.permissions || []).includes(permissionE.disabled)) {
      return true
    }
    // 在字段配置，和cell中展示，不需要只读
    if (this.type !== 'record' && this.type !== 'record_insert') {
      return false
    }
    // 数据权限
    if (!this.canEdit) {
      return true
    }  
    // 人员权限
    return !authorityEdit(this.isAdmin, {canEdit: this.canEdit}, this.item.fieldAuthority, this.state)
  }
  public isUndef (v: any): boolean {
    return v === undefined || v === null
  }
  public blur () {
    if (this.type === 'inCell') {
      this.$emit('fieldBlur', this.form[this.item.businessId])
    }
  }
  public initInsertRecord (isChange = false) {
    if (this.item.defaultType === 2 && (this.isUndef(this.form[this.item.businessId]) || isChange)) {
      this.form[this.item.businessId] = '$defaultValue__' + this.item.defaultValue.replace(reg, (match, $1) => {
        return this.fieldsMap[$1] && this.fieldsMap[$1].name
      })
    }
  }
  public closeFormula () {
    if (!this.disabled) {
      this.form[this.item.businessId] = undefined
    }
  }
  public mounted () {
    if (this.type === 'inCell') {
      this.$nextTick(() => {
        let field = this.$refs.field as any || {}
        if (field.focus) {
          field.focus()
        } else if (field.handleInput) {
          field.handleInput()
        }
      })
    }
  }
}
